import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table__before__summary" }

import { onMounted, ref } from 'vue';
import {
  useTableColumn,
  BaseButton,
  BaseDialog,
  BaseTable,
  XrkMessage,
  BaseTextContent
} from 'xrk-components';
import { formatter } from '@/utils';
import { costItemDetail } from '../../data-source/apis';
import { CostItemDetailData } from '../../data-source/types';

import http from '@/utils/http/axios';


export default /*#__PURE__*/_defineComponent({
  __name: 'cost-detail-dialog',
  props: {
    remove: { type: Function },
    id: {}
  },
  setup(__props: any) {

const props = __props;

const respData = ref<CostItemDetailData>({
  incomeMonth: '',
  costAmount: 0,
  costItem: []
});

const columns = [
  useTableColumn({
    label: '类目',
    prop: 'itemName'
  }),
  useTableColumn({
    label: '比例',
    prop: 'itemValue',
    formatter({ cellValue }) {
      return formatter.fen2yuan(cellValue, '%');
    }
  }),
  useTableColumn({
    label: '占比金额',
    prop: 'amount',
    formatter({ cellValue }) {
      return formatter.fen2yuan(cellValue, '元');
    }
  }),
  useTableColumn({
    label: '上传附件',
    prop: 'handlerCol',
    render: ({ row }) => {
      return (
        row.fileList?.length && (
          <BaseButton
            type="text"
            click={async () => {
              await Promise.all(
                row.fileList.map(async file => {
                  return await http.download(
                    {
                      url: file.url,
                      method: 'GET'
                    },
                    { isShowMessage: false, downloadFileName: file.name }
                  );
                })
              );
              XrkMessage.success('下载成功');
            }}
          >
            下载
          </BaseButton>
        )
      );
    }
  })
];

onMounted(async () => {
  const { data } = await costItemDetail({
    id: props.id
  });
  respData.value = data;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    width: "960px",
    title: "成本列支详情",
    "model-value": true,
    "show-close": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        onClick: _ctx.remove,
        type: "default"
      }, {
        default: _withCtx(() => [
          _createTextVNode("关闭")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(BaseTextContent), null, {
        default: _withCtx(() => [
          _createElementVNode("ul", _hoisted_1, [
            _createElementVNode("li", null, "所属月份：" + _toDisplayString(respData.value.incomeMonth), 1),
            _createElementVNode("li", null, "开票总金额：" + _toDisplayString(_unref(formatter).fen2yuan(respData.value.costAmount, '元')), 1)
          ]),
          _createVNode(_unref(BaseTable), {
            data: respData.value.costItem,
            columns: columns
          }, null, 8, ["data"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})